import {useCustomQuery} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const useOrderDetail = (orderId, options = {}) => {
    const {
        site: {id: siteId},
        locale
    } = useMultiSite()
    const localeId = locale?.id || locale?.alias || ''

    return useCustomQuery(
        {
            options: {
                method: 'POST',
                parameters: {
                    siteId,
                    ...(localeId ? {locale: localeId} : {})
                },
                customApiPathParameters: {
                    apiName: 'order-details',
                    apiVersion: 'v1',
                    endpointPath: '/order-details'
                },
                body: JSON.stringify({
                    orderId
                })
            }
        },
        {
            keepPreviousData: false,
            cacheTime: 0,
            staleTime: 0,
            ...options
        }
    )
}
